import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';
import { getFirmInfo } from '../../../../../services/api';
import Chip from 'Chip';

class SariesNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        firmInfo: [],
    };

    async componentDidMount() {
        try {
            if (this.props.content.carSeriesData.serialId) {
                const firmInfo = await getFirmInfo(this.props.content.carSeriesData.serialId);

                this.setState({
                    firmInfo,
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { content } = this.props;

        const { carSeriesData, seriesNavRecommend } = content;
        const { firmInfo } = this.state;

        return (
            <div className={styles.w1000}>
                <div className={styles.arl_m_tit}>
                    <h2>
                        <a href={firmInfo.corpAddr} target="_blank" rel={rel} title={firmInfo.corpName}>
                            {firmInfo.corpName}
                        </a>-<a
                            href={`https://car.auto.ifeng.com/series/${carSeriesData.serialId}/`}
                            target="_blank"
                            rel={rel}
                            title={carSeriesData.serialName}>
                            {carSeriesData.serialName}
                        </a>
                    </h2>{' '}
                    <span>
                        <a href="//auto.ifeng.com/shanghaichezhan/" target="_blank" rel={rel} />
                    </span>
                </div>
                <div className={styles.arl_subnav}>
                    <ul>
                        <li>
                            <a
                                title={`${carSeriesData.brandName}${carSeriesData.serialName} 车系首页 `}
                                target="_blank"
                                rel={rel}
                                href={`https://car.auto.ifeng.com/series/${carSeriesData.serialId}/`}>
                                车系首页
                            </a>
                        </li>
                        <li>
                            <a
                                title={`${carSeriesData.brandName}${carSeriesData.serialName}  参数配置 `}
                                target="_blank"
                                rel={rel}
                                href={`https://car.auto.ifeng.com/series/${carSeriesData.serialId}/spec/`}>
                                参数配置
                            </a>
                        </li>
                        <li>
                            <a
                                title={`${carSeriesData.brandName}${carSeriesData.serialName}  实拍图片 `}
                                target="_blank"
                                rel={rel}
                                href={`https://data.auto.ifeng.com/photo/s-${carSeriesData.serialId}.html`}>
                                实拍图片
                            </a>
                        </li>
                        <li>
                            <a
                                title={`${carSeriesData.brandName}${carSeriesData.serialName}  报价 `}
                                target="_blank"
                                rel={rel}
                                href={`https://data.auto.ifeng.com/price/s-${carSeriesData.serialId}.html`}>
                                报价
                            </a>
                        </li>
                        <li className={styles.on}>
                            <a
                                title={`${carSeriesData.brandName}${carSeriesData.serialName}  文章 `}
                                target="_blank"
                                rel={rel}
                                href={`https://car.auto.ifeng.com/series/${carSeriesData.serialId}/news/`}>
                                文章
                            </a>
                        </li>
                    </ul>
                    <Chip
                        id="75142"
                        type="recommend"
                        title="车系导航文字链推广位"
                        groupName="content"
                        translate="handleHomeAppRecommendInfo">
                        <div>
                            {seriesNavRecommend[0] ? (
                                <a
                                    className={styles.serial_tuan}
                                    target="_blank"
                                    rel={rel}
                                    href={seriesNavRecommend[0].url}
                                    title={seriesNavRecommend[0].title}>
                                    {seriesNavRecommend[0].title}
                                </a>
                            ) : (
                                ''
                            )}
                        </div>
                    </Chip>
                </div>{' '}
                {/* // <div className={styles.c_m_i}>
            //     <select name="brand" id="brand">
            //         <option value="">请选择品牌</option>
            //     </select>
            //     <select name="serial" id="serial">
            //         <option value="">请选择系列</option>
            //     </select>
            //     <input type="button" value="快速找车" className={styles.btn} id="serach-car" />
            // </div> */}
            </div>
        );
    }
}

export default errorBoundary(SariesNav);
